var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.container},[(_vm.isLoading)?_c('div',{staticClass:"ui inverted active dimmer"},[_c('div',{staticClass:"ui centered inline loader text"},[_vm._v("Cargando")])]):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }